/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MessageTools/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import External from './External/index'
import Internal from './Internal/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MessageTools({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let threadTypeValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: threadTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'External'}>
<External
  viewPath={`${viewPath}/External`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Internal'}>
<Internal
  viewPath={`${viewPath}/Internal`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}